// eslint-disable-next-line no-restricted-globals
export const isValidDate = (d: Date) => d instanceof Date && !isNaN(d.getTime());
